import React, { useEffect, useState } from 'react'
import { Modal, Input, Select, Typography, Row, Col, Divider, Tag } from 'antd'
import { ContainerVisuCSV } from './styled'
import { TitleH2 } from '../../../../../../../../Components/CustomUi/titleH2'
import { TitleH1 } from '../../../../../../../../Components/CustomUi/titleH1'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFlask, faVial, faXmark } from '@fortawesome/free-solid-svg-icons'
import { LineDivider } from '../../../../../../../../Components/CustomUi/LineDivider'

const { Title, Text } = Typography
interface AmostraData {
  id: string
  numero: string
  nome: string
  endereco: string
  propriedade: string
  gleba: string
  // Propriedades Químicas/Físicas
  mg: number
  aluminio: number
  hal: number
  sb: number
  ctc: number
  al_pct: number
  mg_pct: number
  ca_k: number
  mg_k: number
  ferro: number
  manganes: number
  bases_v: number
  percent_ca: number
  percent_k: number
  boro: number
  p: number
  p_rem: number
  ph_cacl2: number
  cobre: number
  zinco: number
  enxofre: number
  teor_argila: number
  teor_silte: number
  mo: number
}

const mockData: AmostraData[] = [
  {
    id: '1',
    numero: '001',
    nome: 'Amostra Alpha',
    endereco: 'Fazenda Boa Esperança',
    propriedade: 'Solo Arenoso',
    gleba: 'Gleba A',
    mg: 0.8,
    aluminio: 0.1,
    hal: 1.5,
    sb: 3.5,
    ctc: 5.0,
    al_pct: 2,
    mg_pct: 4,
    ca_k: 12.5,
    mg_k: 0.4,
    ferro: 25,
    manganes: 10,
    bases_v: 70,
    percent_ca: 50,
    percent_k: 15,
    boro: 17,
    p: 15,
    p_rem: 30,
    ph_cacl2: 5.5,
    cobre: 5.5,
    zinco: 3.0,
    enxofre: 8.0,
    teor_argila: 20,
    teor_silte: 15,
    mo: 2.1,
  },
  {
    id: '2',
    numero: '002',
    nome: 'Amostra Beta',
    endereco: 'Sítio Vista Verde',
    propriedade: 'Solo Misto',
    gleba: 'Gleba B',
    mg: 1.2,
    aluminio: 0.0,
    hal: 1.2,
    sb: 4.0,
    ctc: 6.0,
    al_pct: 0,
    mg_pct: 5,
    ca_k: 10.0,
    mg_k: 0.6,
    ferro: 30,
    manganes: 12,
    bases_v: 75,
    percent_ca: 55,
    percent_k: 10,
    boro: 15,
    p: 18,
    p_rem: 32,
    ph_cacl2: 6.0,
    cobre: 4.0,
    zinco: 2.5,
    enxofre: 7.0,
    teor_argila: 25,
    teor_silte: 10,
    mo: 2.5,
  },
]

interface CsvModalProps {
  isOpen: boolean
  onClose: () => void
  dataCSV: AmostraData[]
}

const CsvVisualizationModal: React.FC<CsvModalProps> = ({ isOpen, onClose, dataCSV }) => {
  const [selectedId, setSelectedId] = useState<string>('')

  const selectedSample = dataCSV.find((item) => item.id === selectedId) || dataCSV[0]

  const DataItem = ({ label, value }: { label: string; value: string | number }) => (
    <div style={{ marginBottom: 12 }}>
      <Text
        type='secondary'
        style={{ display: 'block', fontSize: 11, textTransform: 'uppercase', fontWeight: 600 }}
      >
        {label}
      </Text>
      <Text strong style={{ fontSize: 15 }}>
        {value}
      </Text>
    </div>
  )

  useEffect(() => {
    setSelectedId(dataCSV[0]?.id)
  }, [isOpen])

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      width={'70%'} // Largura grande para acomodar a tabela
      footer={null}
      centered
      bodyStyle={{ padding: 0, height: '70vh', overflow: 'hidden' }}
      closeIcon={false}
    >
      <ContainerVisuCSV>
        <div className='header'>
          <TitleH1>Visualizar análise</TitleH1>
          <FontAwesomeIcon icon={faXmark} fontSize={18} style={{cursor: 'pointer'}} onClick={onClose} />
        </div>

        <div className='modal__infos'>
          <div>
            <label>Nome proprietário</label>
            <p>{selectedSample?.nome}</p>
          </div>
          <div>
            <label>Endereço</label>
            <p>{selectedSample?.endereco}</p>
          </div>
          <div>
            <label>Propriedade</label>
            <p>{selectedSample?.propriedade}</p>
          </div>
        </div>

        <div className='body__conteudo'>
          <div className='campo__amostra'>
            <label className='title'>Análises</label>
            <div style={{ overflowY: 'auto' }}>
              {dataCSV?.map((item) => {
                return (
                  <div
                    key={item.id}
                    onClick={() => setSelectedId(item.id)}
                    className='selecionar__amostra'
                    data-active={item.id === selectedId}
                  >
                    <label>#{item.numero}</label>
                  
                     <div>
                      <div className='circle__selecionada' data-active={item.id === selectedId}></div>
                     </div>
                 
                  </div>
                )
              })}
            </div>
          </div>

          <div className='detalhes__amostra '>
            <div className='header__detalhe'>
              {/* <div className='fundo__icone'>
                <FontAwesomeIcon icon={faFlask} className='icone' />
              </div> */}
              <TitleH2 style={{fontSize:'13px'}}>Detalhes Completos da Amostra</TitleH2>
            </div>
            <div className='conteudo__analises'>
              {/* Linha 1 (Dados Cadastrais) */}
              <DataItem label='NÚMERO' value={selectedSample?.numero} />
              <DataItem label='MG' value={selectedSample?.mg} />
              <DataItem label='CA/K' value={selectedSample?.ca_k} />
              <DataItem label='BORO' value={selectedSample?.boro} />

              {/* Linha 2 */}
              <DataItem label='ALUMÍNIO' value={selectedSample?.aluminio} />
              <DataItem label='MG/K' value={selectedSample?.mg_k} />
              <DataItem label='P' value={selectedSample?.p} />

              {/* Linha 3 */}
              <DataItem label='H+AL' value={selectedSample?.hal} />
              <DataItem label='FERRO' value={selectedSample?.ferro} />
              <DataItem label='P REM' value={selectedSample?.p_rem} />

              {/* Linha 4 */}
              <DataItem label='SB' value={selectedSample?.sb} />
              <DataItem label='MANGANÊS' value={selectedSample?.manganes} />
              <DataItem label='PH EM CACL2' value={selectedSample?.ph_cacl2} />

              {/* Linha 5 */}
              <DataItem label='GLEBA' value={selectedSample?.gleba} />
              <DataItem label='CTC' value={selectedSample?.ctc} />
              <DataItem label='BASES V%' value={selectedSample?.bases_v} />
              <DataItem label='COBRE' value={selectedSample?.cobre} />

              {/* Linha 6 */}
              <DataItem label='M.O.' value={selectedSample?.mo} />
              <DataItem label='AL M%' value={selectedSample?.al_pct} />
              <DataItem label='%CA' value={selectedSample?.percent_ca} />
              <DataItem label='ZINCO' value={selectedSample?.zinco} />

              {/* Linha 7 */}
              <DataItem label='P REM' value={selectedSample?.p_rem} />
              <DataItem label='%MG' value={selectedSample?.mg_pct} />
              <DataItem label='%K' value={selectedSample?.percent_k} />
              <DataItem label='TEOR DE SILTE' value={selectedSample?.teor_silte} />
            </div>
          </div>
        </div>
      </ContainerVisuCSV>
    </Modal>
  )
}

export default CsvVisualizationModal
